/**
 * School badges (ป้ายสำนัก): a disciple's standing in their school, earned by cultivating the
 * school's own neigong. Each tier, once the neigong reaches its level, is claimed for a title and
 * the school uniform of that rank — a little grander at every step. Rank only: nothing here makes a
 * fighter stronger.
 */
import { SCHOOLS } from './schools';

export interface BadgeTier {
  /** 1 to 4. */
  readonly tier: number;
  /** The badge itself: iron, bronze, silver, gold. */
  readonly name: string;
  /** Rank in the school; the title is this followed by the school's name. */
  readonly rank: string;
  /** Level of the school's neigong it needs. */
  readonly level: number;
  /** Badge metal colour, for the client to draw it. */
  readonly color: string;
}

export const BADGE_TIERS: readonly BadgeTier[] = [
  { tier: 1, name: 'ป้ายเหล็ก', rank: 'ศิษย์ชั้นใน', level: 5, color: '#8a9098' },
  { tier: 2, name: 'ป้ายสำริด', rank: 'ศิษย์เอก', level: 10, color: '#c07a3a' },
  { tier: 3, name: 'ป้ายเงิน', rank: 'ผู้อาวุโส', level: 15, color: '#d8dee8' },
  { tier: 4, name: 'ป้ายทอง', rank: 'ผู้พิทักษ์', level: 20, color: '#f0c040' },
];

export const MAX_BADGE = BADGE_TIERS.length;

export const badgeTitleId = (school: string, tier: number): string => `badge-${school}-${tier}`;

/** The title a tier's badge carries in a school: "ศิษย์เอกสำนักยอดหมอก". */
export function badgeTitleName(school: string, tier: number): string {
  const sc = SCHOOLS[school];
  const t = BADGE_TIERS[tier - 1];
  return sc && t ? `${t.rank}สำนัก${sc.name}` : '';
}
